import { observable } from 'mobx';

export type WifiElementResponseArgs = {
  id: number;
  summary: string;
};

export type WifiElementArgs = {
  id: number;
  summary: string;
};

export const convertWifiElementResponseToArgs = (response: WifiElementResponseArgs) => {
  const args: WifiElementArgs = {
    id: response.id,
    summary: response.summary
  };
  return args;
};

export default class WifiElement {
  @observable
  id: number;

  @observable
  summary: string;

  constructor(args: WifiElementArgs) {
    this.id = args.id;
    this.summary = args.summary;
  }

  get type() {
    return 'wifi';
  }

  get title() {
    return 'WiFi';
  }

  get name() {
    return this.title;
  }

  detail() {
    return '';
  }
}
